
import { useRef, useEffect, useCallback } from 'react'
import { useNats } from '../../providers/NatsProvider.jsx'

export const useGetNatsImage = () => {
  const { natsService } = useNats()
  
  // Track all created blob URLs for cleanup
  const activeUrls = useRef(new Set())
  
  // Optional cache
  const imageCache = useRef(new Map())


  const getImgFromNats = useCallback(async (serverURL, bucket, fileName, isCached = false) => {
    if (!fileName) return null

    // 1. If caching is requested, check cache first
    if (isCached) {
      if (imageCache.current.has(fileName)) {
        return imageCache.current.get(fileName)
      }
      // Handle non-nats images (cache the string itself)
      if (!fileName.includes('nats')) {
        imageCache.current.set(fileName, fileName)
        return fileName
      }
    }

    // 2. Fetch from NATS
    if (!natsService) return null
    
    try {
      const blob = await natsService.getImgFromNats(serverURL, bucket, fileName)
      
      if (blob) {
        const url = URL.createObjectURL(blob)
        activeUrls.current.add(url) // Track for cleanup
        
        // Save to cache if requested
        if (isCached) {
          imageCache.current.set(fileName, url)
        }
        return url
      }
      return null
    } catch (error) {
      console.error('Error fetching image from NATS:', error)
      return null
    }
  }, [natsService])

  // AUTOMATIC CLEANUP
  useEffect(() => {
    return () => {
      // Clean up all tracked blob URLs when component unmounts
      activeUrls.current.forEach(url => {
        URL.revokeObjectURL(url)
      })
      activeUrls.current.clear()
      imageCache.current.clear()
    }
  }, [])

  return { 
    getImgFromNats,
    imageCache: imageCache.current 
  }
}
